package org.solyton.solawi.bid.module.shares.action

import org.evoleq.math.contraMap
import org.evoleq.optics.storage.Action
import org.evoleq.optics.transform.add
import org.solyton.solawi.bid.module.shares.data.api.PricingType
import org.solyton.solawi.bid.module.shares.data.toDomainType
import org.solyton.solawi.bid.module.shares.data.api.ApiShareOffer
import org.solyton.solawi.bid.module.shares.data.api.CreateShareOffer
import org.solyton.solawi.bid.module.shares.data.management.ShareManagement
import org.solyton.solawi.bid.module.shares.data.management.shareOffers

fun createShareOffer(
    providerId: String,
    shareTypeId: String,
    fiscalYearId: String,
    price: Double?,
    pricingType: PricingType,
    ahcAuthorizationRequired: Boolean,
    nameSuffix: String = ""
): Action<ShareManagement, CreateShareOffer, ApiShareOffer> = Action(
    name = "CreateShareOffer$nameSuffix",
    reader = { _ ->
        CreateShareOffer(
            providerId = providerId,
            shareTypeId = shareTypeId,
            fiscalYearId = fiscalYearId,
            price = price,
            pricingType = pricingType,
            ahcAuthorizationRequired = ahcAuthorizationRequired
        )
    },
    endPoint = CreateShareOffer::class,
    writer = shareOffers.add() contraMap { sT: ApiShareOffer -> sT.toDomainType()}
)
